export const environment = {
    BASE_URL: 'https://formsubmission-e5e6f5fvfcawdmgg.westus-01.azurewebsites.net/api',
};
